export const calculateSecondCoef = (
    coef: string | number,
    percent: number,
    coefNumber: number
): number => Number(coef) < 1 + percent
    ? -coefNumber / (percent - coefNumber)
    : coefNumber / (coefNumber - 1) * percent;
